export class Rewards {
    membershipid: number;
    reference: string;
    label: string;
    type: string;
    value: number;
    rewardid: number;
    applied: boolean;
    quantityavailable: number;
    quantityapplied: number;
    description: string;
    fineprint: string;
    imageurl: string;
    validminutes: number;
    availableonline: boolean;
    availableoffline: boolean;
    expirationdate: string;
    externalreference: string;
    vendorrefs: Array<string>;
    items: Array<number>;
    categories: Array<number>;

    public static Make(obj: any): Rewards {
        const rewards = new Rewards();
        Object.assign(rewards, obj);
        return rewards;
    }
}
